import intlTelInput from "intl-tel-input";

export class PhoneNumberInput {
    private $element: JQuery;
    private $input: JQuery;

    private plugin: intlTelInput.Plugin;

    constructor(label: string, intent?: boolean, value?: string) {
        this.$element = $('<div class="phonenumberinput formcontrol' + (intent === true ? " intent" : "") + '" />');
        this.$element.append("<label>" + label + "</label>");
        this.$input = $('<input type="tel" value="' + (value !== undefined ? value : "") + '" />').appendTo(
            this.$element
        );

        const initialCountry = "ch";
        this.plugin = intlTelInput(this.$input[0], {
            preferredCountries: ["ch", "de", "fr", "it"],
            initialCountry: initialCountry,
            allowDropdown: true,
            autoPlaceholder: "aggressive",
            nationalMode: true,
            separateDialCode: true,
            utilsScript: "./assets/scripts/libs/intl-tel-input-utils.js",
        });
    }

    public isValid(): boolean {
        return this.plugin.isValidNumber();
    }

    public getNumber(): string | undefined {
        const nr = this.plugin.getNumber();
        if (nr.length === 0) return undefined;

        return nr;
    }

    public getCountryCode(): string | undefined {
        const ext = this.plugin.getSelectedCountryData();
        if (ext === undefined) return undefined;

        return ext.dialCode;
    }

    public setValue(number?: string): PhoneNumberInput {
        this.plugin.setNumber(number === undefined ? "" : number);
        return this;
    }

    public destroy() {
        this.plugin.destroy();
    }

    public setError(hasError: boolean): PhoneNumberInput {
        if (hasError) this.$element.addClass("has-error");
        else this.$element.removeClass("has-error");

        return this;
    }

    public appendTo($element: JQuery): PhoneNumberInput {
        this.$element.appendTo($element);
        return this;
    }
}
